var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm._v(
      _vm._s(_vm.formattedPrefix) +
        _vm._s(_vm.calculatedPrice) +
        _vm._s(_vm.formattedSuffix)
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-680e6efe", { render: render, staticRenderFns: staticRenderFns })
  }
}